import { useState, useRef, useEffect, useContext, useCallback, useMemo, useLayoutEffect } from 'react';
import { Spin } from 'antd';
import { useApplyFilterMutation } from 'hooks/general/useApplyFilterMutation';
import _, { debounce } from 'lodash';
import { useFetchAttributeNames } from 'hooks/Filter/useFetchAttributeNames';
import Down from 'assets/svg/Down';
import { FilterContextData } from '../../../contexts/FilterContext';
import {
    createObjectForCheckList,
    previousAttributeSelection,
    excludeIncludeEngine,
    getApplyFilterObject,
    returnApplyFilter,
    constructFilterObject,
} from 'parser/filterParser';
import { Button, Popover } from 'antd';
import InfiniteScroller from '../InfiniteScroller';
import FilterSelectionCount from './FilterSelectionCount';
import FilterSelectAllCheckBox from 'components/atoms/Filter/FilterSelectAllCheckBox';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig, fetchScopeID, deleteTypeNameFromResponse } from 'utils/helperMethods';
import { client } from 'services/apolloInit';
import FilterAttrNameList from 'components/atoms/Filter/FilterAttrNameList';
import { trackEventMixpanel } from 'utils/mixpanel';
import { GLOBAL_FILTER_SEARCH } from 'utils/mixpanelEventNames';
import { useLocation } from 'react-router-dom';
import { useFetchAttributeNamesV2 } from 'hooks/Filter/useFetchAttributeNamesV2';
import { filterUrls } from 'config/urls';

interface Props {
    attributeType?: any;
    dimension: any;
    attributeTypeExpandFlag: Boolean;
    globalFilterContainerId: string;
}

const attributeNamesContainerId = 'attribute-names-pop-container';

export const MultiSelectionDropDown: React.FC<Props> = ({
    attributeType,
    dimension,
    attributeTypeExpandFlag,
    globalFilterContainerId,
}) => {
    const {
        allAttributeNames,
        setAllAttributeNames,
        allCheckedAttribute,
        setAllCheckedAttribute,
        setPreviousSelectedAttributesInUI,
        applyFilterObject,
        setApplyFilterObject,
        allSelectedValueForAllAttribute,
        setAllSelectedValueForAllAttribute,
        screenFilterConfig,
    } = useContext(FilterContextData);
    const [openPopup, setOpenPopup] = useState(false);
    const refForOnlyInternalshowList = useRef(false);
    const { appConfig } = useContext(UserContext);
    const filterConfig = getConfig('globalFilter', appConfig);
    const searchKeywordRef = useRef<any>(null);
    const currentScreenFeatureName = screenFilterConfig?.dimensionListKey || 'default';
    const GlobalFilterNav = document.getElementById(globalFilterContainerId);
    const [variables, setVariables] = useState<any>(null);
    //hook call will to set attribute name and also to manage infinite scroll and checked attribute
    // const {
    //     data: attributeNames,
    //     loading: attributeNamesLoading,
    //     error: attributeNamesError,
    //     fetchAttributeNames,
    //     count,
    //     isActiveCount,
    // } = useFetchAttributeNames(
    //     setAllCheckedAttribute,
    //     allSelectedValueForAllAttribute,
    //     attributeType,
    //     allCheckedAttribute,
    //     setAllAttributeNames,
    //     allAttributeNames,
    //     openPopup,
    //     applyFilterObject,
    //     dimension,
    // );
    useEffect(() => {
        if (openPopup) {
            setVariables({
                limit: filterConfig.limit,
                offset: 0,
                searchKeyword: _.trim(searchKeywordRef.current?.value),
                searchDimension: dimension.dimensionReference,
                featureName: currentScreenFeatureName,
                attributeType: attributeType?.name,
                email: localStorage.getItem('email'),
                filters: constructFilterObject(applyFilterObject, attributeType?.name),
            });
        }
    }, [openPopup]);

    //get attribute names hook
    const {
        loading: attributeNamesLoading,
        error: attributeNamesError,
        count,
        isActiveCount,
    } = useFetchAttributeNamesV2({
        method: 'post',
        queryConfig: { enabled: Boolean(openPopup) && Boolean(variables) && Boolean(variables?.filters) },
        queryKey: ['global-filter', 'global-filter-attribute-types', variables],
        url: `${filterUrls.getAttributeNamesUrl}`,
        variables: { ...variables },
        extras: {
            dimension: dimension.dimensionReference,
            allAttributeNames,
            allSelectedValueForAllAttribute,
            setAllCheckedAttribute,
            setAllAttributeNames,
            applyFilterObject,
            allCheckedAttribute,
        },
    });

    //show list function
    const showList = () => {
        setOpenPopup(!openPopup);
        refForOnlyInternalshowList.current = !refForOnlyInternalshowList.current;
    };

    //onclick of dropdown
    let onClickOfDropdown = (attributeName: any | undefined) => {
        showList();

        // Disable body scroll when dropdown is open
        if (!openPopup) {
            document.body.style.overflow = 'hidden';
            if (GlobalFilterNav) {
                GlobalFilterNav.style.overflow = 'hidden';
            }
        } else {
            document.body.style.overflow = 'auto';
            if (GlobalFilterNav) {
                GlobalFilterNav.style.overflow = 'auto';
            }
        }
    };

    //onclick of checkbox of attribute name
    const onClickCheckbox = (
        checkBoxObj: any,
        e: any,
        attributeType: string,
        setAllCheckedAttribute: Function,
        allCheckedAttribute: any,
        dimension: any,
        allSelectedValueForAllAttribute: Boolean,
        attributeNamesData: any,
    ) => {
        createObjectForCheckList(checkBoxObj, e, attributeType, setAllCheckedAttribute, allCheckedAttribute);
        previousAttributeSelection(setPreviousSelectedAttributesInUI, e, allCheckedAttribute, attributeType, dimension);
        excludeIncludeEngine(
            checkBoxObj,
            e,
            attributeType,
            applyFilterObject,
            setApplyFilterObject,
            dimension,
            allSelectedValueForAllAttribute,
            attributeNamesData,
        );
    };

    //trigger by the infinite scroll component
    const infiniteScrollOnNext = (loading: boolean) => {
        if (!loading) {
            const newOffset = variables.offset + filterConfig.limit;
            setVariables({ ...variables, offset: newOffset });
        }
    };

    //placeholder setter function
    function valueOfInputBox(allAttributeNamesList: any, CheckAttributeObj: any) {
        //default selection placeholder
        if (!allAttributeNamesList && filterConfig.promoScoreCardDefault !== undefined) {
            if (attributeType.name in filterConfig.promoScoreCardDefault) {
                return 'Multiple Selection';
            } else {
                return 'Multiple Selection';
            }
        } else if (allAttributeNamesList !== undefined) {
            //default selection
            for (let attrName of allAttributeNamesList) {
                if (attrName?.isActive) {
                    if (!CheckAttributeObj || !(attrName?.attributeExId in CheckAttributeObj)) {
                        return 'Multiple Selection';
                    }
                }
            }
            return 'All';
        }
    }

    //debounced mixpanel function
    function mixpanelFunction(attrDetails: any, string: string) {
        trackEventMixpanel(GLOBAL_FILTER_SEARCH, {
            dimension: attrDetails?.dimensionReference,
            searchKeyword: string,
            attributeType: attrDetails?.name,
        });
    }

    //debounced search function
    function searchChangeHandler(val: string) {
        moveScrollbarToTop();
        setVariables((prev: any) => {
            return {
                ...(prev || {}),
                searchKeyword: val,
                offset: 0,
            };
        });
    }

    const debouncedSearch = useCallback(debounce(searchChangeHandler, 300), [variables]);

    //memo debounce function
    const deBouncedMixpanelFunction = useCallback(debounce(mixpanelFunction, 500), [attributeType]);

    //moves popup scrollbar to top
    function moveScrollbarToTop() {
        //infinite scrollable element
        const tableScrollableElement = document
            .getElementById(attributeNamesContainerId)
            ?.getElementsByClassName('infinite-scroll-component')[0];
        tableScrollableElement;
        tableScrollableElement?.scrollTo?.({
            top: 0,
            behavior: 'auto',
        });
    }

    //onchange of search value
    function onSearch(e: any) {
        setOpenPopup(true);

        // deBounce(e.target.value);
        debouncedSearch(e.target.value);
        //mixpanel event
        deBouncedMixpanelFunction(attributeType, e.target.value);
    }

    const dropdownRef = useRef<HTMLDivElement>(null);
    const dropdownBoxRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Event listener to handle clicks outside the dropdown
        const handleClickOutside = (event: any) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node) &&
                dropdownBoxRef.current &&
                !dropdownBoxRef.current.contains(event.target as Node)
            ) {
                setOpenPopup(false);
                // Unable body scroll when dropdown is close
                document.body.style.overflow = 'auto';
                if (GlobalFilterNav) {
                    GlobalFilterNav.style.overflow = 'auto';
                }
            }
        };
        // Attach the event listener to the document
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const content = (
        <div id={attributeNamesContainerId} ref={dropdownRef}>
            {attributeNamesLoading && variables?.offset === 0 ? (
                <div className="h-32 flex justify-center items-center" style={{ height: '328px' }}>
                    <Spin />
                </div>
            ) : (
                <InfiniteScroller
                    data={allAttributeNames[attributeType.name]}
                    loading={attributeNamesLoading}
                    hasMore={allAttributeNames[attributeType.name]?.length < count}
                    height={328}
                    onNext={() => infiniteScrollOnNext(attributeNamesLoading)}
                >
                    <ul style={{ opacity: attributeNamesLoading && variables?.offset > 0 ? 0.4 : 1 }}>
                        {!attributeNamesError && allAttributeNames?.[attributeType.name]?.length ? (
                            <li className={`flex mx-3 mt-2 ${searchKeywordRef.current?.value.length && `justify-end`}`}>
                                {!searchKeywordRef.current?.value.length && (
                                    <FilterSelectAllCheckBox
                                        attributeType={attributeType.name}
                                        setAllCheckedAttribute={setAllCheckedAttribute}
                                        allCheckedAttribute={allCheckedAttribute}
                                        allAttributeNames={allAttributeNames[attributeType.name]}
                                        allSelectedValueForAllAttribute={allSelectedValueForAllAttribute}
                                        setAllSelectedValueForAllAttribute={setAllSelectedValueForAllAttribute}
                                        setApplyFilterObject={setApplyFilterObject}
                                        applyFilterObject={applyFilterObject}
                                        dimension={dimension}
                                    />
                                )}
                                <FilterSelectionCount
                                    allCheckedAttribute={allCheckedAttribute?.[attributeType.name]}
                                    allAttributeNames={allAttributeNames?.[attributeType.name]}
                                    allCount={isActiveCount}
                                    allSelectedValueForAllAttribute={allSelectedValueForAllAttribute}
                                    attributeType={attributeType.name}
                                    searchLength={searchKeywordRef.current?.value.length}
                                />
                            </li>
                        ) : (
                            <li className="flex justify-center items-center h-full w-full mt-6">Not Found</li>
                        )}
                        {allAttributeNames?.[attributeType.name]?.map((item: any, index: number) => (
                            <FilterAttrNameList
                                key={index} // Add key prop for each item in map
                                index={index}
                                allCheckedAttribute={allCheckedAttribute}
                                item={item}
                                attributeType={attributeType}
                                onClickCheckbox={onClickCheckbox}
                                setAllCheckedAttribute={setAllCheckedAttribute}
                                dimension={dimension}
                                allSelectedValueForAllAttribute={allSelectedValueForAllAttribute}
                                attributeNames={allSelectedValueForAllAttribute}
                            />
                        ))}
                    </ul>
                </InfiniteScroller>
            )}
        </div>
    );

    return (
        <div className="inline-block w-full relative">
            <Popover
                trigger={'click'}
                showArrow={false}
                open={openPopup}
                overlayInnerStyle={{
                    position: 'relative',
                    width: '251px',
                    top: 8,
                }}
                placement="bottomLeft"
                overlayClassName="popover-padding-remove"
                content={content}
            >
                <div
                    ref={dropdownBoxRef}
                    className="flex items-center w-full justify-between px-3 py-1 border border-purpleFont bg-white rounded"
                >
                    <input
                        type="text"
                        className="font-sm border-0 focus:outline-none w-full py-1 placeholder-black"
                        onChange={(e) => onSearch(e)}
                        ref={searchKeywordRef}
                        placeholder={valueOfInputBox(
                            allAttributeNames?.[attributeType.name],
                            allCheckedAttribute?.[attributeType.name],
                        )}
                    />
                    <span
                        className="z-10 font-normal text-center w-8 mr-[-10px] h-10 flex justify-center cursor-pointer items-center"
                        onClick={() => onClickOfDropdown(attributeType)}
                    >
                        <Down />
                    </span>
                </div>

                {/* This empty div will be hidden based on openPopup */}
                <div className={`${openPopup ? '' : 'hidden'}`}></div>
            </Popover>
        </div>
    );
};
